/**
 * @fileoverview
 * Info Table Component - Display information in table format
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, Input, ChangeDetectionStrategy, computed } from '@angular/core';


export interface InfoTableItem {
  label: string;
  value: string | number | null | undefined;
}

interface TableRow {
  item1: InfoTableItem;
  item2: InfoTableItem | null;
}

@Component({
  selector: 'app-info-table',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './info-table.component.html',
  styleUrl: './info-table.component.css',
})
export class InfoTableComponent {
  @Input() tableData: InfoTableItem[] = [];
  @Input() headerText: string = '';
  @Input() subHeading: string = '';

  // Group data into pairs for two-column display
  pairedData = computed(() => {
    const pairs: TableRow[] = [];
    for (let i = 0; i < this.tableData.length; i += 2) {
      pairs.push({
        item1: this.tableData[i],
        item2: i + 1 < this.tableData.length ? this.tableData[i + 1] : null
      });
    }
    return pairs;
  });
}

